import React from "react";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import InputText from "../../common/Input/InputText";
import InputOnlyNumber from "../../common/Input/InputOnlyNumber";

const AddUpdateMedicineMaster = ({
  modalVisible,
  setModalVisible,
  selectedAction,
  handleAddOrUpdateMedicine,
  handleSetMedicineFormData,
  handleSetDepartmentEdit,
  handleSetMedicineTypeEdit,
  medicineFormData,
  specializations,
  setInputError,
  medicineType,
}) => {
  return (
    <>
      <Modal
        centered
        show={modalVisible}
        onHide={() => setModalVisible(false)}
        size="lg"
      >
        <div className="modal-header">
          <h3 className="modal-title" id="exampleModalLabel">
            {selectedAction === "Update" ? "Update Medicine" : "Add Medicine"}
          </h3>
          <button
            type="button"
            className="btn-close"
            onClick={() => setModalVisible(false)}
          ></button>
        </div>
        <div className="modal-body">
          <form onSubmit={handleAddOrUpdateMedicine}>
            <div className="row">
              <div className="col-xl-6">
                <InputText
                  label="Generic Name"
                  name="genericName"
                  value={medicineFormData?.genericName}
                  onChange={(e) => handleSetMedicineFormData(e)}
                  className="form-control"
                  placeholder="Generic Name"
                  setInputTextError={setInputError}
                  fieldName="Generic Name"
                />
              </div>
              <div className="col-xl-6">
                <InputText
                  label="Brand Name"
                  name="brandName"
                  value={medicineFormData?.brandName}
                  onChange={(e) => handleSetMedicineFormData(e)}
                  className="form-control"
                  placeholder="Brand Name"
                  setInputTextError={setInputError}
                  fieldName="Brand Name"
                  required={true}
                />
              </div>
              <div className="col-xl-6">
                <InputText
                  label="Manufacturer"
                  name="manufacturer"
                  value={medicineFormData?.manufacturer}
                  onChange={(e) => handleSetMedicineFormData(e)}
                  className="form-control"
                  placeholder="Manufacturer"
                  setInputTextError={setInputError}
                  fieldName="Manufacturer"
                />
              </div>
              <div className="col-xl-6">
                <div className="form-group position-relative">
                  <label htmlFor="department" className="col-form-label">
                    Department:
                  </label>

                  <Select
                    isMulti
                    value={specializations
                      ?.filter((item) =>
                        medicineFormData?.department?.includes(item?._id)
                      )
                      ?.map((item) => ({
                        value: item?._id,
                        label: item?.department,
                      }))}
                    onChange={handleSetDepartmentEdit}
                    options={specializations?.map((item) => ({
                      value: item?._id,
                      label: item?.department,
                    }))}
                  />
                </div>
              </div>
              <div className="col-xl-6">
                <div className="form-group position-relative">
                  <label htmlFor="medicineType" className="col-form-label">
                    Medicine Type:
                  </label>

                  <Select
                    value={
                      medicineFormData?.medicineType
                        ? {
                            value: medicineFormData?.medicineType,
                            label: medicineFormData?.medicineTypeName,
                          }
                        : null
                    }
                    onChange={handleSetMedicineTypeEdit}
                    options={medicineType?.map((item) => ({
                      value: item?._id,
                      label: item?.name,
                    }))}
                    placeholder="Medicine Type"
                  />
                </div>
              </div>
              <div className="col-xl-6">
                <InputText
                  label="CIMS"
                  name="cims"
                  value={medicineFormData?.cims}
                  onChange={(e) => handleSetMedicineFormData(e)}
                  className="form-control"
                  placeholder="CIMS"
                  setInputTextError={setInputError}
                  fieldName="Cims"
                />
              </div>
              <div className="col-xl-6">
                <InputText
                  label="ATC"
                  name="atc"
                  value={medicineFormData?.atc}
                  onChange={(e) => handleSetMedicineFormData(e)}
                  className="form-control"
                  placeholder="ATC"
                  setInputTextError={setInputError}
                  fieldName="Atc"
                />
              </div>
              <div className="col-xl-6">
                <InputText
                  label="Pack Size"
                  name="packSize"
                  value={medicineFormData?.packSize}
                  onChange={(e) => handleSetMedicineFormData(e)}
                  className="form-control"
                  placeholder="Pack Size"
                  setInputTextError={setInputError}
                  fieldName="PackSize"
                />
              </div>
              <div className="col-xl-6">
                <InputText
                  label="Storage Temperature"
                  name="storageTemperature"
                  value={medicineFormData?.storageTemperature}
                  onChange={(e) => handleSetMedicineFormData(e)}
                  className="form-control"
                  placeholder="Storage Temperature"
                  setInputTextError={setInputError}
                  fieldName="StorageTemperature"
                />
              </div>
              <div className="col-xl-6">
                <InputOnlyNumber
                  label="Expiry Period"
                  name="expiryPeriod"
                  value={medicineFormData?.expiryPeriod}
                  onChange={(e) => handleSetMedicineFormData(e)}
                  className="form-control"
                  placeholder="Expiry Period"
                  setInputTextError={setInputError}
                  fieldName="ExpiryPeriod"
                />
              </div>
              <div className="col-xl-6">
                <InputText
                  label="Composition"
                  name="composition"
                  value={medicineFormData?.composition}
                  onChange={(e) => handleSetMedicineFormData(e)}
                  className="form-control"
                  placeholder="Composition"
                  setInputTextError={setInputError}
                  fieldName="Composition"
                />
              </div>
              <div className="col-xl-6">
                <InputText
                  label="Strength"
                  name="strength"
                  value={medicineFormData?.strength}
                  onChange={(e) => handleSetMedicineFormData(e)}
                  className="form-control"
                  placeholder="Strength"
                  setInputTextError={setInputError}
                  fieldName="Strength"
                />
              </div>
              <div className="col-xl-6">
                <InputText
                  label="Usage"
                  name="usage"
                  value={medicineFormData?.usage}
                  onChange={(e) => handleSetMedicineFormData(e)}
                  className="form-control"
                  placeholder="Usage"
                  setInputTextError={setInputError}
                  fieldName="Usage"
                />
              </div>
              <div className="col-xl-6">
                <div className="form-group d-flex align-items-center">
                  <label htmlFor="status" className="col-form-label me-3">
                    Status:
                  </label>
                  {["Active", "Inactive", "Deleted"].map((status) => (
                    <div className="form-check me-3" key={status}>
                      <input
                        className="form-check-input"
                        type="radio"
                        name="status"
                        id={status?.toLowerCase()}
                        value={status}
                        checked={medicineFormData?.status === status}
                        onChange={handleSetMedicineFormData}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={status.toLowerCase()}
                      >
                        {status}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setModalVisible(false)}
              >
                Close
              </button>
              <button type="submit" className="btn btn-success">
                {selectedAction === "Update" ? "Update" : "Save"}
              </button>
            </div>
          </form>
        </div>
      </Modal>
    </>
  );
};

export default AddUpdateMedicineMaster;
